const E = "small", e = "medium", m = "large", a = {
  small: { name: E, prefix: "" },
  medium: { name: e, prefix: "md" },
  large: { name: m, prefix: "lg" }
};
export {
  a as default
};
